import { call } from "redux-saga/effects";
import { API_URLS } from "../resources/constants";
import { formQueryString } from '../resources/functions';
import { CallApi } from './callApi';

// QuickBooks incremental re-sync (gl-api /qb-sync) -- shared by QuickBooks Online
// and QuickBooks Desktop. Ids travel as sessionId; request bodies as `body`.

const base = API_URLS.QB_SYNC.BASE;
const qs = (params: any) => {
  const q = formQueryString(params || {});
  return q ? `?${q}` : '';
};

function* run(action: any, fn: any, url: string, body: any = {}): any {
  try {
    const result = yield call(fn, url, body, true);
    action && action.callbackSuccess(result);
  } catch (e) {
    action && action.callbackError(e);
  }
}

export function* status(action: any): any {
  yield* run(action, CallApi.GET, `${base}/status` + qs(action.payload));
}

export function* settings(action: any): any {
  yield* run(action, CallApi.PUT, `${base}/settings`, action.payload);
}

export function* start(action: any): any {
  yield* run(action, CallApi.POST, `${base}/sessions`, action.payload);
}

export function* session(action: any): any {
  yield* run(action, CallApi.GET, `${base}/sessions/${action.payload.sessionId}`);
}

export function* changes(action: any): any {
  const { sessionId, month } = action.payload;
  yield* run(action, CallApi.GET, `${base}/sessions/${sessionId}/changes` + qs(month ? { month } : {}));
}

export function* months(action: any): any {
  const { sessionId, months } = action.payload;
  yield* run(action, CallApi.PATCH, `${base}/sessions/${sessionId}/months`, { months });
}

export function* apply(action: any): any {
  yield* run(action, CallApi.POST, `${base}/sessions/${action.payload.sessionId}/apply`);
}

export function* cancel(action: any): any {
  yield* run(action, CallApi.POST, `${base}/sessions/${action.payload.sessionId}/cancel`);
}
